const momsProducts = [
  {
    id: 1,
    title: "Babybear Bag 🐻",
    handle: "babybear-bag",
    defaultVariantId: "50216387019033",
    variants: [
      { name: "Red", id: "50216386953497", price: 49.95, comparePrice: 79.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-1.jpg?v=1777061004" },
      { name: "Black", id: "50216387051801", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Black8.jpg?v=1777061004" },
      { name: "Blue", id: "50216387019033", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-3.jpg?v=1777061004" },
      { name: "Grey", id: "50216386986265", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-2.jpg?v=1777061004" }
    ]
  },
  {
    id: 2,
    title: "Cuddle Cub 🧸",
    handle: "cuddle-cub",
    variants: [
      { name: "Grey", id: "51217711563033", price: 15.00, comparePrice: 20.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_13ab440d-0fb7-40ac-94ba-ee97e7d4c10f.webp?v=1756297567" }
    ]
  },
  {
    id: 3,
    title: "Mamourse EasySeat 🪑",
    handle: "mamourse-easyseat",
    variants: [
      { name: "Grey", id: "52288229277977", price: 17.47, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_0bb1f4ee-14e8-449c-8cc7-bf745e7fe7a7.jpg?v=1777208806" }
    ]
  },
  {
    id: 4,
    title: "Mamourse Mom's Essentials Organizer 👜",
    handle: "mamourse-moms-essentials-organizer",
    variants: [
      { name: "Grey", id: "50216409334041", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20231016-WA0092.jpg?v=1697553805" }
    ]
  }
];

let momsStockSynced = false;

async function syncMomsShopifyStock() {
  for (const product of momsProducts) {
    try {
      const res = await fetch(`/products/${product.handle}.js`);
      if (!res.ok) continue;

      const data = await res.json();

      product.variants.forEach(variant => {
        const liveVariant = data.variants.find(v => String(v.id) === String(variant.id));
        if (liveVariant) {
          variant.inStock = liveVariant.available;
          variant.price = liveVariant.price / 100;
          variant.comparePrice = liveVariant.compare_at_price ? liveVariant.compare_at_price / 100 : null;
        }
      });
    } catch (error) {
      console.warn("Stock/price sync failed:", product.title);
    }
  }
  momsStockSynced = true;
}

function getMomsSavePercentage(price, comparePrice) {
  if (!comparePrice || comparePrice <= price) return null;
  return Math.round(((comparePrice - price) / comparePrice) * 100);
}

function getMomsDefaultVariant(product) {
  if (product.defaultVariantId) {
    const chosen = product.variants.find(v => String(v.id) === String(product.defaultVariantId));
    if (chosen && chosen.inStock) return chosen;
  }
  return product.variants.find(v => v.inStock) || product.variants[0];
}

function renderMomsProducts() {
  const grid = document.getElementById("momsGrid");
  if (!grid) return;

  grid.innerHTML = "";

  momsProducts.forEach(product => {
    const firstVariant = getMomsDefaultVariant(product);
    const displayImage = product.defaultImage || firstVariant.image;
    const savePercent = getMomsSavePercentage(firstVariant.price, firstVariant.comparePrice);

    const card = document.createElement("article");
    card.className = "moms-card";

    let dropdownOptions = "";

    product.variants.forEach(variant => {
      const selected = String(variant.id) === String(firstVariant.id) ? "selected" : "";
      const soldOutClass = !variant.inStock ? "sold-out-option" : "";

      dropdownOptions += `
        <option
          value="${variant.id}"
          data-price="${variant.price}"
          data-compare="${variant.comparePrice || ""}"
          data-image="${variant.image}"
          data-title="${product.title}"
          data-instock="${variant.inStock}"
          class="${soldOutClass}"
          ${selected}>
          ${variant.name}
        </option>
      `;
    });

    card.innerHTML = `
      <div class="moms-card-image-container">
        ${savePercent ? `<span class="sale-badge">SAVE ${savePercent}%</span>` : ""}

        <img src="${displayImage}" alt="${product.title}" class="moms-card-image" loading="lazy">

        <div class="image-overlay">
          <a href="/products/${product.handle}" class="view-details-btn">
            <svg viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/>
            </svg>
            <span>View Details</span>
          </a>
        </div>

        <button class="image-cart-btn add-to-cart-mobile ${!firstVariant.inStock ? "sold-out-mobile" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
        </button>

        ${!firstVariant.inStock ? `<div class="mobile-sold-out">Sold Out</div>` : ""}
      </div>

      <div class="moms-card-info">
        <h3 class="moms-card-title">${product.title}</h3>

        <div class="variant-selector">
          <select class="variant-dropdown ${!firstVariant.inStock ? "selected-sold-out" : ""}">
            ${dropdownOptions}
          </select>
        </div>

        <div class="moms-card-price">
          <span class="current-price">$${firstVariant.price.toFixed(2)}</span>
          ${firstVariant.comparePrice ? `<span class="compare-price">$${firstVariant.comparePrice.toFixed(2)}</span>` : ""}
        </div>

        <button class="add-to-cart-btn add-to-cart-desktop ${!firstVariant.inStock ? "sold-out" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
          <span>${firstVariant.inStock ? "Add to Cart" : "Sold Out"}</span>
        </button>
      </div>
    `;

    grid.appendChild(card);
  });

  attachMomsEventListeners();
}

function attachMomsEventListeners() {
  document.querySelectorAll(".variant-dropdown").forEach(dropdown => {
    dropdown.addEventListener("change", function () {
      const card = this.closest(".moms-card");
      const option = this.options[this.selectedIndex];

      const variantId = option.value;
      const price = parseFloat(option.dataset.price);
      const compare = option.dataset.compare ? parseFloat(option.dataset.compare) : null;
      const image = option.dataset.image;
      const productTitle = option.dataset.title;
      const inStock = option.dataset.instock === "true";

      const imageEl = card.querySelector(".moms-card-image");
      const priceEl = card.querySelector(".current-price");
      const compareEl = card.querySelector(".compare-price");
      const desktopBtn = card.querySelector(".add-to-cart-desktop");
      const mobileBtn = card.querySelector(".add-to-cart-mobile");
      const imageContainer = card.querySelector(".moms-card-image-container");

      imageEl.src = image;
      priceEl.textContent = `$${price.toFixed(2)}`;

      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = `$${compare.toFixed(2)}`;
          compareEl.style.display = "inline";
        } else {
          compareEl.style.display = "none";
        }
      }

      desktopBtn.dataset.variantId = variantId;
      desktopBtn.dataset.price = price;
      mobileBtn.dataset.variantId = variantId;
      mobileBtn.dataset.price = price;

      const existingBadge = card.querySelector(".mobile-sold-out");

      if (inStock) {
        this.classList.remove("selected-sold-out");

        desktopBtn.disabled = false;
        desktopBtn.classList.remove("sold-out");
        desktopBtn.querySelector("span").textContent = "Add to Cart";

        mobileBtn.disabled = false;
        mobileBtn.classList.remove("sold-out-mobile");

        if (existingBadge) existingBadge.remove();
      } else {
        this.classList.add("selected-sold-out");

        desktopBtn.disabled = true;
        desktopBtn.classList.add("sold-out");
        desktopBtn.querySelector("span").textContent = "Sold Out";

        mobileBtn.disabled = true;
        mobileBtn.classList.add("sold-out-mobile");

        if (!existingBadge) {
          const badge = document.createElement("div");
          badge.className = "mobile-sold-out";
          badge.textContent = "Sold Out";
          imageContainer.appendChild(badge);
        }
      }
    });
  });

  document.querySelectorAll(".add-to-cart-desktop").forEach(button => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });

  document.querySelectorAll(".add-to-cart-mobile").forEach(button => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  renderMomsProducts();
  syncMomsShopifyStock().then(function () {
    renderMomsProducts();
  });
});